import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../../../service/component_dependent/messages/messages.service';
import { StorageService } from '../../../service/managers/storage.service';
import { ConversationService } from '../../../service/component_dependent/messages/conversation.service';
import { UsersService } from '../../../service/component_dependent/users/users.service'
import { Router,ActivatedRoute } from '@angular/router'
import { Subject } from "rxjs/Subject";


import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-messages-navigation',
  templateUrl: './messages-navigation.component.html',
  styleUrls: ['./messages-navigation.component.scss']
})
export class MessagesNavigationComponent implements OnInit {

  protected countAllMessages: number = 0;
  protected countAllConversation: number = 0;
  protected countUnread: number = 0;
  protected countSent: number = 0;

  cssConv = '';
  cssMsg = '';
  cssUnread = '';
  cssSent = '';

  protected countOutgoingConversations: number = 0;
  protected countUnreadConversations: number = 0;
  userList = [];
   selStaff:any = "";
   selUser:any = "";

  private staffidsub:any;

  constructor(private messageService: MessagesService,
    private storageService: StorageService,
    private userService: UsersService,
    private router:Router,
    private activatedRoute: ActivatedRoute,
    private http:HttpClient,
    private conversationService: ConversationService) { }

    ngOnDestroy(){
      this.staffidsub.unsubscribe();
    }

  ngOnInit() {
    console.log('Navigation INIT')
    this.getAssignedStaffList();
    this.staffidsub = this.conversationService.$staffid.subscribe(
      (data) => {
        console.log('Data SERVICE:' + JSON.stringify(data))
        this.selUser = data.userID
        this.loadAll();
      }
    )

    this.activatedRoute.params.subscribe(
      (data: any) => {
         
         console.log('Navigation Query String:' + JSON.stringify(data))
         this.selUser = data.id
      }
    )

    this.loadAll();

  }

  private loadAll(){
    let userID;
    let reqObj;
    userID = this.storageService.getUser().id;

    if(this.selStaff!=''){
      userID = this.selStaff;
    }

    console.log('Load All User ID:' + userID)

    reqObj = {
      user_id: userID,
    };

    this.messageService.getCountAllMessages(userID,'unread').subscribe(
      (dataMessage: any) => {
        this.countUnread = dataMessage.data.total;
      },
      (errorMessage: any) => { },
    );

    this.messageService.getCountAllMessages(userID,'sent').subscribe(
      (dataMessage: any) => {
        this.countSent = dataMessage.data.total;
      },
      (errorMessage: any) => { },
    );

    this.messageService.getCountAllMessages(userID,'allconversation').subscribe(
      (dataMessage: any) => {
        this.countAllConversation = dataMessage.data.total;
        console.log('Count COnversation:' + this.countAllConversation)
      },
      (errorMessage: any) => { },
    );

    this.messageService.getCountAllMessages(userID,'all').subscribe(
      (dataMessage: any) => {
        this.countAllMessages = dataMessage.data.total;
      },
      (errorMessage: any) => { },
    );

  }


  public getAssignedStaffList(){
    this.userService.getAssignedUsers().subscribe(
      (data) => { 
         this.userList = data;
      },
      (err) => {
         alert('Error Getting StaffList:' + JSON.stringify(err))
      }
    )
  }

  public staffInboxLoad(){
    this.loadAll()
    var myurl = `smsblast/messages/all/${this.selStaff}`;
    this.router.navigateByUrl(myurl)
    console.log('Load User Inbox of staff:' + this.selStaff)
  
  }


  export(){
     this.http.get('http://localhost:8090/joytogive/backend/public/api/testexport',{responseType: 'arraybuffer'})
     .subscribe(
       (data:any) =>{
        var blob = new Blob([data], {type: "application/ms-excel"});
        var objectUrl = URL.createObjectURL(blob);

        saveAs(objectUrl,"user.xlsx");

    //FileSaver.saveAs(file);
        //var url = window.URL.createObjectURL(blob);
        //window.open(objectUrl);
       }
     )
  }

}
